__turbopack_context__.v({
  "uploadedFileIndicator": "UploadedFileIndicator-module__Yk8TdG__uploadedFileIndicator",
  "uploadedFileIndicatorAdditional": "UploadedFileIndicator-module__Yk8TdG__uploadedFileIndicatorAdditional",
  "uploadedFileIndicatorComplete": "UploadedFileIndicator-module__Yk8TdG__uploadedFileIndicatorComplete",
  "uploadedFileIndicatorLoading": "UploadedFileIndicator-module__Yk8TdG__uploadedFileIndicatorLoading",
  "uploadedFileIndicatorWaiting": "UploadedFileIndicator-module__Yk8TdG__uploadedFileIndicatorWaiting",
});
